// Fetch list

export const FETCH = 'reportDriverCosts.FETCH'
export const FETCH_STARTED = 'reportDriverCosts.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportDriverCosts.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportDriverCosts.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportDriverCosts.FETCH_CANCELLED'

// Export

export const EXPORT = 'reportDriverCosts.EXPORT'
export const EXPORT_FULFILLED = 'reportDriverCosts.EXPORT_FULFILLED'

// Clear

export const CLEAR = 'reportDriverCosts.CLEAR'

// Fetch details

export const FETCH_DETAILS = 'reportDriverCosts.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportDriverCosts.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportDriverCosts.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportDriverCosts.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportDriverCosts.FETCH_DETAILS_CANCELLED'

// Export details

export const EXPORT_DETAILS = 'reportDriverCosts.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportDriverCosts.EXPORT_DETAILS_FULFILLED'

// Clear details

export const CLEAR_DETAILS = 'reportDriverCosts.CLEAR_DETAILS'
